import { bindRequestLogic } from './utils'
import ExcludedDomainTypes from '../actionTypes/excludedDomain'
import { excludedDomainAPI } from '../api'

const getExcludedDomains = bindRequestLogic({
  clientFunc: excludedDomainAPI.getExcludedDomains,
  type: ExcludedDomainTypes.GET_EXCLUDED_DOMAINS_REQUEST,
  successType: ExcludedDomainTypes.GET_EXCLUDED_DOMAINS_SUCCESS,
  failType: ExcludedDomainTypes.GET_EXCLUDED_DOMAINS_FAILED,
  isQueryParam: true
})

const addExcludedDomain = bindRequestLogic({
  clientFunc: excludedDomainAPI.addExcludedDomain,
  type: ExcludedDomainTypes.ADD_EXCLUDED_DOMAIN_REQUEST,
  successType: ExcludedDomainTypes.ADD_EXCLUDED_DOMAIN_SUCCESS,
  failType: ExcludedDomainTypes.ADD_EXCLUDED_DOMAIN_FAILED
})

const updateExcludedDomain = bindRequestLogic({
  clientFunc: excludedDomainAPI.updateExcludedDomain,
  type: ExcludedDomainTypes.UPDATE_EXCLUDED_DOMAIN_REQUEST,
  successType: ExcludedDomainTypes.UPDATE_EXCLUDED_DOMAIN_SUCCESS,
  failType: ExcludedDomainTypes.UPDATE_EXCLUDED_DOMAIN_FAILED
})

const deleteExcludedDomain = bindRequestLogic({
  clientFunc: excludedDomainAPI.deleteExcludedDomain,
  type: ExcludedDomainTypes.DELETE_EXCLUDED_DOMAIN_REQUEST,
  successType: ExcludedDomainTypes.DELETE_EXCLUDED_DOMAIN_SUCCESS,
  failType: ExcludedDomainTypes.DELETE_EXCLUDED_DOMAIN_FAILED
})

export default [
  getExcludedDomains,
  addExcludedDomain,
  updateExcludedDomain,
  deleteExcludedDomain
]
